import { makeStyles } from '@mui/styles';
import { CSSProperties } from 'react';
import { Colors } from '../../../ui/theme/colors';

export const useLoginTabStyles = makeStyles(() => ({
  selected: {
    backgroundColor: `${Colors.deliveredBlue}1A !important`,
    borderColor: `${Colors.deliveredBlue} !important`,
    color: `${Colors.deliveredBlue} !important`
  }
}));

export const fullWidthStyle: CSSProperties = { width: '100%' };
export const rowGroupStyle: CSSProperties = { width: '100%', margin: 0, padding: '8px 16px' };

export const loginDetailsSectionStyle: CSSProperties = {
  ...rowGroupStyle,
  borderTop: `1px solid ${Colors.lightGray}`,
  borderBottom: `1px solid ${Colors.lightGray}`
};

export const dialogActionsStyle: CSSProperties = {
  borderTop: `1px solid ${Colors.lightGray}`,
  padding: '16px 24px'
};
